import OFFER_DETAILS_CONSTANT from './OfferDetails.constants';

export const setOfferDetails = (payload) => {
  return {
    type: OFFER_DETAILS_CONSTANT.SET_OFFER_DETAILS_DATA,
    payload,
  };
};

export const getOfferDetails = (payload) => {
  return {
    type: OFFER_DETAILS_CONSTANT.GET_OFFER_DETAILS_DATA,
    payload,
  };
};
